import { useOktaAuth } from "@okta/okta-react";
import { IconDealerStaff } from "@cdkglobal/radial";
import { useEffect, useRef, useState } from "react";
import {
  StyledDropdownButton,
  StyledUserContextMenu,
} from "../../utils/styled";
import { useUserContext } from "../../contexts/UserContext";
import { isUnifyLaunch } from "../../contexts/iframe/launchMode";

const UserMenu = ({ isCollapsed }: { isCollapsed: boolean }): JSX.Element => {
  const { oktaAuth } = useOktaAuth();
  const { fullName } = useUserContext();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const isUnify = isUnifyLaunch(window.location.search);

  const logout = async () => {
    oktaAuth.tokenManager.clear();
    localStorage.clear();

    await oktaAuth.signOut({
      clearTokensAfterRedirect: true,
      revokeAccessToken: true,
      revokeRefreshToken: true,
    });
  };

  const toggleMenu = () => setIsOpen((prevIsOpen) => !prevIsOpen);

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div ref={menuRef}>
      <StyledDropdownButton
        onClick={toggleMenu}
        data-testid="navigation-user-dropdown-button"
        avatarProps={{
          icon: <IconDealerStaff />,
          label: "All Options",
          variant: "icon",
        }}
        dropdownLabel={fullName}
        isOpen={isOpen}
        isCollapsed={isCollapsed}
      />

      {isOpen && (
        <StyledUserContextMenu
          data-testid="navigation-user-context-menu"
          avatarProps={{
            label: fullName || "",
            variant: "text",
          }}
          listItems={[]}
          onSignOut={logout}
          usernameTitle={fullName}
          $hideSignOut={isUnify}
        />
      )}
    </div>
  );
};

export default UserMenu;
